import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import { isEqual } from 'lodash';
import '../../utils/index.js';
import { Grid } from '@sketch/components';
import Section from '../Section/Section.js';
import '../Section/components/Item/index.js';
import '../DiscoverFooter/index.js';
import { Wrapper, Title, SubTitle, Separator, StyledGrid } from './Discover.styles.js';
import { filterContentByPermissions } from '../../utils/filterContent.js';
import Items from '../Section/components/Item/Item.js';
import DiscoverFooter from '../DiscoverFooter/DiscoverFooter.js';

// Returns an array with the roles (example: ["editor", "admin"])
const createRolesArray = (userRole) => Object.keys(userRole).reduce((acc, key) => userRole[key] === true ? [...acc, key.toUpperCase()] : acc, []);
/**
 *
 * Discover
 *
 * Renders the content for the Discover Page
 */
const Discover = props => {
    const { data, workspace } = props;
    // Professional Roles have been removed and the empty string is a temporary fix to avoid breaking the app
    // Discover now load a marketing website page and this Discover component is not used anymore but still kept around.
    //
    // We should be safe to remove the entire Discover feature but for now, we just want to remove professional role
    const audience = 'DESIGNERS';
    const roles = createRolesArray({
        editor: workspace.userCanEdit,
        viewer: !workspace.userCanEdit,
        admin: workspace.userRole === 'ADMIN',
    });
    const userPermissions = {
        audience,
        roles,
    };
    const filteredSection = filterContentByPermissions({
        userPermissions,
        contents: data.discover.sections,
    });
    return (jsxs(Wrapper, { children: [jsx(Title, { children: "Discover" }), jsx(SubTitle, { children: "Explore our curated selection of posts, resources, and artwork \u2014 made with love and Sketch." }), jsx(Separator, {}), jsxs(StyledGrid, { children: [filteredSection.map(section => (jsx(Section, Object.assign({ context: 'DISCOVER', userPermissions: userPermissions, itemComponent: Items }, section), section.id))), jsx(Grid.Column, { children: jsx(DiscoverFooter, {}) })] })] }));
};
var Discover$1 = React.memo(Discover, isEqual);

export { Discover$1 as default };
